import React, { useMemo, useState, useEffect } from "react";
import PropTypes from "prop-types";
import TableContainer from "../../components/Common/TableContainer";
import Swal from "sweetalert2";
import { getAllCategories } from "service/api";

function DatatableTables_categories({ onViewRow }) {
  const [monthUpdates, setCategories] = useState([]);

  useEffect(() => {
    fetchAllCategories();
  }, []);

  const fetchAllCategories = async () => {
    try {
      const res = await getAllCategories();
      setCategories(res.data || []);
    } catch (error) {
      console.error("Error fetching Categories:", error);
    }
  };

  const columns = useMemo(
    () => [
      {
        Header: "Sr. No.",
        Cell: ({ row }) => row.index + 1,
      },
      {
        Header: "Category",
        accessor: "category_name",
      },
      {
        Header: "Actions",
        id: "action_column",
        Cell: ({ row }) => (
          <button
            type="button"
            className="btn btn-warning ml-2"
            onClick={() => onViewRow && onViewRow(row.original)}
          >
            <i className="mdi mdi-eye"></i>
          </button>
        ),
      },
    ],
    [onViewRow]
  );

  return (
    <div className="page-content">
      <div className="container-fluid">
        {monthUpdates && (
          <TableContainer
            columns={columns}
            data={monthUpdates}
            isGlobalFilter={true}
            isAddOptions={false}
            customPageSize={10}
            className="custom-header-css"
          />
        )}
      </div>
    </div>
  );
}

DatatableTables_categories.propTypes = {
  preGlobalFilteredRows: PropTypes.any,
  onViewRow: PropTypes.func,
};

export default DatatableTables_categories;
